import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.min.css";

function PropertyListOut() {
  const [properties, setProperties] = useState([]);

  useEffect(() => {
    axios
      .get("http://127.0.0.1:8000/api/residential/residential_view/")
      .then((response) => setProperties(response.data))
      .catch((error) => console.error("Error fetching properties:", error));
  }, []);

  return (
    <div className="container-fluid mt-4">
      <h3 className="mb-4 text-center">🏡 Residential Properties</h3>
      <div className="row">
        {properties.length === 0 ? (
          <p className="text-center">No properties found.</p>
        ) : (
          properties.map((property) => (
            <div className="col-md-3 mb-4" key={property.id}>
              <div className="card h-100 shadow-sm">
                <img
                  src={`http://127.0.0.1:8000${property.Image}`}
                  className="card-img-top"
                  alt={property.BhkType}
                  style={{ height: "200px", objectFit: "cover" }}
                />
                <div className="card-body">
                  <h5 className="card-title">{property.BhkType}</h5>
                  <p className="card-text">
                    <strong>District:</strong> {property.District} <br />
                    <strong>Town:</strong> {property.Town} <br />
                    <strong>Price:</strong> ₹{property.ExpectedRent}
                  </p>
                </div>
                <div className="card-footer text-center">
                  <Link to={`/property/${property.id}`} className="btn btn-primary">
                    View
                  </Link>
                </div>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
}

export default PropertyListOut;
